/* Application mode. Stored in master state. Designates which main part of the main login flow is currently active. */
export const Mode = {
    LOGIN: 'login' /* During login, verification (keycode+mobilekey) and when showing errors. */,
    REP: 'rep' /* During representation management and when redirecting to success URL. */,
};

/* Representation management mode. Stored in master state. Designates which part of the representation flow is currently active. */
export const RepMode = {
    AUTO_SELECT: 'auto_select' /* When trying to select correct representation automatically after login. */,
    CHANGE_REP_INIT: 'init_change_rep' /* When we are initializing change representation page. */,
    LIST: 'list' /* When user is presented a representation list. */,
    LIST_SELECT: 'list_select' /* When user has selected a representation from the list. */,
    ERROR: 'error' /* When error has happened in representation selection and we don't immediately go back to login screen (ie. error when changing rep) */,
};

/* Error codes of internal logic. */
export const ErrorCode = {
    AUTHENTICATION_FAILED: 'authentication_failed',
    PASSWORD_CHANGE_REQUIRED: 'password_change_required',
    VERIFICATION_FAILED: 'verification_failed',
    VERIFICATION_CANCEL: 'verification_cancel',
    TRUSTNETWORK_CANCEL: 'trustnetwork_cancel',
    REPRESENTATIONS_NOT_FOUND: 'representations_not_found',
    REPRESENTATIONS_HAS_ERROR: 'representations_has_error',
    SELECT_REPRESENTATION_FAILED: 'select_representation_failed',
    REPRESENTATION_LIST_FAILED: 'representation_list_failed',
    AUTH_METHOD_FORBIDDEN: 'auth_method_forbidden',
    ISVA_FORBIDDEN: '0x38cf0427',
};

/* Representation types */
export const RepresentationType = {
    PERSON: 'PERSON',
    HA_BANK: 'HA_BANK',
    YDAS: 'YDAS',
    KOPA: 'KOPA',
    YOP: 'YOP',
    YRVEIKKO: 'YRVEIKKO',
    YA_BANK: 'YA_BANK',
};

/* Representation types that are considered person representations */
export const PERSON_REPRESENTATION_TYPES = [RepresentationType.PERSON, RepresentationType.HA_BANK];

/* Representation types that are considered company representations */
export const COMPANY_REPRESENTATION_TYPES = [
    RepresentationType.YDAS,
    RepresentationType.KOPA,
    RepresentationType.YOP,
    RepresentationType.YRVEIKKO,
    RepresentationType.YA_BANK,
];

/* Tells the type of login that was used. CHANGEREP value is when we come to the app via change representation link.  */
export const LoginType = {
    OPLOGIN: 'OPLOGIN',
    FTN: 'FTN',
    IDKAART: 'IDKAART',
    CHANGEREP: 'CHANGEREP',
    UNKNOWN: 'UNKNOWN',
};

/* Tells the current phase in login flow from UI perspective.  */
export const LoginUiPhase = {
    CREDENTIALS: 'CREDENTIALS',
    VERIFY: 'VERIFY',
};

/* HTML element attributes */
export const fullpageloginRootId = 'fullpagelogin-root';
export const fullpageloginContainerId = 'fullpagelogin-container';
export const loginContainerId = 'login-container';
export const representationContainerId = 'representation-container';
export const cancelButtonContainerId = 'cancelbutton-container';
